import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env; 
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/integracaoParametroController');
const axiosMotivo = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/motivoController');
const axiosMatriz = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/matrizController');
const axiosOriginador = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/originadorController');

export default class IntegracaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasIntegracoesPaginado(page: number, size: number) {
    return await this.axios.get(`/listarPaginado?page=${page}&size=${size}`);
  }

  async listarPorId(id: any) {
    return await this.axios.get(`/buscarPorId?id=${id}`);
  }

  async salvar(dto: any) {
    return await this.axios.post(`/salvar`, dto);
  }

  async excluir(id: any) {
    return await this.axios.delete(`/excluir?id=${id}`);
  }
  
  async listarParametrosDefinicao(tipoIntegracao: string) {
    return await this.axios.get(`/listarParametrosDefinicao?tipoIntegracao=${tipoIntegracao}`);
  }

  async verificarGeneralizada(integracao: string) {
    return await this.axios.get(`/verificarGeneralizada?integracao=${integracao}`);
  }

  async verificarSeExisteOutra(integracao: string, id?: number) {
    const url = id 
        ? `/verificarSeExisteIntegracao?integracao=${integracao}&id=${id}`
        : `/verificarSeExisteIntegracao?integracao=${integracao}`;
        
    return await this.axios.get(url);
  }

  async verificarIntegracaoAtiva(integracao: string) {
    return await this.axios.get(`/verificarIntegracaoAtiva?integracao=${integracao}`);
  }

  async listarTodosMotivos(){
    return await axiosMotivo.get(`/listarTodosMotivos`);
  }

  async listarTodasMatrizesAtivas() {
    return await axiosMatriz.get(`/listarTodasMatrizesAtivas`);
  }

  async listarTodosOriginadoresAtivos(){
    return await axiosOriginador.get(`/listarTodosOriginadoresAtivos`);
  }

  async buscarMatrizPorId(id: any){
    return await axiosMatriz.get(`/listarMatrizPorId?id=${id}`);
  }

  async buscarOriginadorPorId(id: any){
    return await axiosOriginador.get(`/listarOriginadorPorId?id=${id}`);
  }
}
